import { getDurationInMs } from "@trainline-shareable/utils";
const getLegDuration = ({ localDepartAt, localArriveAt }) => getDurationInMs(localDepartAt, localArriveAt);
var getLegDuration_default = getLegDuration;
export {
  getLegDuration_default as default
};
